export const NEWAIRLINE = "new";
export const EDITAIRLINE = "edit";
